module.exports = __webpack_public_path__ + "static/media/HSP40_initial_sequences.2b3e39bf.zip";